import type { Dictionary } from './dictionaryTypes';

type SettingsPhoneChangeDictionary = Pick<
    Dictionary['settings'],
    | 'changePhoneNumberTitle'
    | 'changePhoneNumberCopy'
    | 'changePhoneNumberWarning'
    | 'changePhoneNumberNewPhoneLabel'
    | 'changePhoneNumberNewPhonePlaceholder'
    | 'changePhoneNumberOtpLabel'
    | 'changePhoneNumberRecoveryCodeLabel'
    | 'changePhoneNumberRequestOtp'
    | 'changePhoneNumberComplete'
    | 'changePhoneNumberRequesting'
    | 'changePhoneNumberCompleting'
    | 'changePhoneNumberSuccess'
    | 'changePhoneNumberOtpSent'
    | 'changePhoneNumberRecoveryCodesTitle'
    | 'changePhoneNumberRecoveryCodesCopy'
    | 'changePhoneNumberRecoveryCodesDone'
>;

export const SETTINGS_PHONE_CHANGE_EN: SettingsPhoneChangeDictionary = {
    changePhoneNumberTitle: 'Phone number',
    changePhoneNumberCopy: 'Changing this number changes the login and recovery phone for every device.',
    changePhoneNumberWarning: 'Use a recovery code to confirm the change. The old number stops working after completion.',
    changePhoneNumberNewPhoneLabel: 'New phone number',
    changePhoneNumberNewPhonePlaceholder: 'New number',
    changePhoneNumberOtpLabel: 'New-phone code',
    changePhoneNumberRecoveryCodeLabel: 'Recovery code',
    changePhoneNumberRequestOtp: 'Send code',
    changePhoneNumberComplete: 'Change number',
    changePhoneNumberRequesting: 'Sending…',
    changePhoneNumberCompleting: 'Changing…',
    changePhoneNumberSuccess: 'Phone number changed.',
    changePhoneNumberOtpSent: 'Code sent to the new number.',
    changePhoneNumberRecoveryCodesTitle: 'Save your new recovery codes',
    changePhoneNumberRecoveryCodesCopy: 'Your recovery codes were rotated after the phone change. Save these new codes before closing this sheet.',
    changePhoneNumberRecoveryCodesDone: 'I saved these codes',
};

export const SETTINGS_PHONE_CHANGE_RU: SettingsPhoneChangeDictionary = {
    changePhoneNumberTitle: 'Номер телефона',
    changePhoneNumberCopy: 'Изменение номера меняет телефон для входа и восстановления на всех устройствах.',
    changePhoneNumberWarning: 'Подтвердите изменение кодом восстановления. Старый номер перестанет работать после завершения.',
    changePhoneNumberNewPhoneLabel: 'Новый номер',
    changePhoneNumberNewPhonePlaceholder: 'Новый номер',
    changePhoneNumberOtpLabel: 'Код на новый номер',
    changePhoneNumberRecoveryCodeLabel: 'Код восстановления',
    changePhoneNumberRequestOtp: 'Отправить код',
    changePhoneNumberComplete: 'Изменить номер',
    changePhoneNumberRequesting: 'Отправляем…',
    changePhoneNumberCompleting: 'Изменяем…',
    changePhoneNumberSuccess: 'Номер изменён.',
    changePhoneNumberOtpSent: 'Код отправлен на новый номер.',
    changePhoneNumberRecoveryCodesTitle: 'Сохраните новые коды восстановления',
    changePhoneNumberRecoveryCodesCopy: 'После смены номера коды восстановления обновились. Сохраните эти новые коды перед закрытием.',
    changePhoneNumberRecoveryCodesDone: 'Я сохранил коды',
};
